import React, { useContext } from 'react';
import { Col } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { DashboardContext } from '../../context/DashboardContext';

const Widget = () => {
  const { widgets } = useContext(DashboardContext);

  return (
    <React.Fragment>
      <Col xl={12}>
        <div className="row">
          {widgets.map((item, idx) => (
            <div className="col-lg-3" key={idx}>
              <div className="card">
                <div className="card-body d-flex gap-3 align-items-center">
                  <div className="avatar-sm">
                    <div className={`avatar-title border bg-${item.bgColor}-subtle border-${item.bgColor} border-opacity-25 rounded-2 fs-17`}>
                      <FeatherIcon icon={item.icon} className={`icon-dual-${item.bgColor}`} />
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <h5 className="fs-15">{item.count.toLocaleString('fa-IR')}</h5>
                    <p className="mb-0 text-muted">{item.label}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Col>
    </React.Fragment>
  );
};

export default Widget;